/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsListUserObjects204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsListUserObjects505Schema = z.any();

export const optionsListUserObjectsMutationResponseSchema = z.lazy(() => optionsListUserObjects204Schema);
